// src/stores/adminStore.js
import { create } from "zustand";

export const useAdminStore = create((set) => ({
  // --- State ---
  locale: null, // Default locale
  countries: [], // The list will be populated by the component
  
  // --- Actions ---
  setLocale: (newLocale) => set({ locale: newLocale }),

  // New action for the component to call
  setCountries: (countryList) => set({ countries: countryList }),
}));
